import React from 'react';
import { MapPin, Clock, CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { serviceAreas } from '../mock';

const ServiceAreas = () => {
  return (
    <section id="service-areas" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Service Areas
          </h2>
          <p className="text-lg text-gray-600">
            We proudly serve 4 cities in Georgia with convenient pickup and delivery schedules
          </p>
        </div>

        {/* Cities grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {serviceAreas.map((area) => (
            <Card key={area.id} className="border-2 hover:border-teal-300 transition-all duration-300 hover:shadow-lg">
              <CardHeader>
                <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center mb-3">
                  <MapPin className="text-teal-600" size={24} />
                </div>
                <CardTitle className="text-xl">{area.city}</CardTitle>
                <CardDescription className="flex items-center gap-2 text-base">
                  <Clock size={16} />
                  {area.pickupTime}
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-2">
                <div className="flex items-start gap-2 text-sm">
                  <CheckCircle2 className="text-green-500 flex-shrink-0 mt-0.5" size={16} />
                  <span className="text-gray-600">{area.sameDay}</span>
                </div>
                <div className="flex items-start gap-2 text-sm">
                  <CheckCircle2 className="text-blue-500 flex-shrink-0 mt-0.5" size={16} />
                  <span className="text-gray-600">{area.nextDay}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Service schedule info */}
        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 border-2 border-teal-100">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Flexible Pickup & Delivery Schedule
            </h3>
            <div className="grid sm:grid-cols-2 gap-6 text-left">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                    <CheckCircle2 className="text-green-600" size={20} />
                  </div>
                  <h4 className="font-bold text-lg text-gray-900">Same-Day Service*</h4>
                </div>
                <p className="text-gray-600">
                  Same-day service available for qualifying orders picked up before 4:00 PM.
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                    <Clock className="text-blue-600" size={20} />
                  </div>
                  <h4 className="font-bold text-lg text-gray-900">After 4:00 PM</h4>
                </div>
                <p className="text-gray-600">
                  Pickups after 4:00 PM will be delivered the following day.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
